module.exports = __webpack_public_path__ + "img/logogo.5b87df0a.png";